// Every empty state answers "what should I do next?" (spec §39). The
// action slot is optional so the public site (nothing for a customer to
// "do") and the admin editor (which passes a real action button) can
// share this component.
export function EmptyState({ title, description, action }) {
  return (
    <div className="rm-empty-state">
      <p className="rm-empty-state__title">{title}</p>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
